// extracted by mini-css-extract-plugin
export default {"single_notification":"SingleNotification_single_notification__2PsOC","single_notification__profile_pic":"SingleNotification_single_notification__profile_pic__gcjeo"};